export default "__VITE_ASSET__DiUK5_F6__"